import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCheckboxLargeComponent } from "./med-icon-checkbox-large.component";

@NgModule({
  declarations: [
    MedIconCheckboxLargeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCheckboxLargeComponent,
  ],
})
export class MedIconCheckboxLargeModule { }
